import { render, staticRenderFns } from "./EditDealer.vue?vue&type=template&id=b8bf1e86&"
import script from "./EditDealer.vue?vue&type=script&lang=js&"
export * from "./EditDealer.vue?vue&type=script&lang=js&"
import style0 from "./EditDealer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EditDealer.vue"
export default component.exports